fuzzySupertypes